<!-- 器械基础资料 -->
<template>
   <div class='page_content'>
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
         append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <surgicalKitAction v-if="showStatus" ref="surgicalKitAction" @drawerCancel="drawerCancel" @toDetail="toDetail"
            :actionData="actionData"></surgicalKitAction>
      </el-drawer>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <v-search :searchList="formList" :getRequestData="getRequestData" @searchData="searchData"
               @openSearch="openSearch"></v-search>
         </div>
      </div>
      <div class="page_content_center">
         <div class="left">
            <el-menu :default-active="defaultActive" class="el-menu-vertical-demo">
               <el-submenu :index="String(item.id)" v-for="(item, index) in treeList" :key="`item${index}`">
                  <template slot="title">
                     <i class="el-icon-folder"></i>
                     <span>{{ item.surgeryName }}</span>
                  </template>
                  <el-menu-item-group>
                     <el-menu-item :index="String(val.umId)" v-for="(val, key) in item.children" :key="`val${key}`"
                        @click="toTab(val.umId)">
                        <i class="el-icon-document"></i>
                        <span>{{ val.umName }}</span>
                     </el-menu-item>
                  </el-menu-item-group>
               </el-submenu>
            </el-menu>
         </div>
         <div class="right">
            <div class="right_top">
               <el-breadcrumb separator="/">
                  <el-breadcrumb-item>{{ defaultObj.surgeryName }}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ defaultObj.umName }}</el-breadcrumb-item>
               </el-breadcrumb>
            </div>
            <el-table ref="myTable" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum"
               border style="width: 100%" highlight-current-row size="mini">
               <el-table-column align="center" show-overflow-tooltip label="商品名称" prop="bgmName"
                  min-width="120"></el-table-column>
               <el-table-column align="center" show-overflow-tooltip label="商品编号" prop="bgmCode"
                  min-width="120"></el-table-column>
               <el-table-column align="center" show-overflow-tooltip label="规格" prop="spec"
                  min-width="120"></el-table-column>
               <el-table-column align="center" show-overflow-tooltip label="生产厂商" prop="manufacturer"
                  min-width="120"></el-table-column>
               <el-table-column align="center" show-overflow-tooltip label="数量" prop="num"
                  min-width="120"></el-table-column>
               <el-table-column align="center" show-overflow-tooltip label="备注" prop="remark"
                  min-width="120"></el-table-column>
            </el-table>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData"
            @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
         <initDataUpload :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
         </initDataUpload>
      </el-dialog>
   </div>
</template>
<script>
import SearchScheme from "@/byComponents/SearchScheme.vue";
import surgicalKitAction from "@/components/surgicalKitAction.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      surgicalKitAction,
   },
   data() {
      //这里存放数据
      return {
         buttonList: [],
         formList: [
            {
               entityField: "surgeryName",
               fieldType: "string",
               formatterContent: null,
               isRequired: 0,
               isShow: 1,
               searchId: null,
               extractId: null,
               setField: null,
               showField: "手术类型",
            },
            {
               entityField: "umName",
               fieldType: "string",
               formatterContent: null,
               isRequired: 0,
               isShow: 1,
               searchId: null,
               extractId: null,
               setField: null,
               showField: "手术包名称",
            },


         ],
         tableHeight: 0,
         getRequestData: {},
         returnData: {
            list: [],
         },
         seId: "",
         seWidth: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         smId: "",
         parentSearchData: {},
         sField: "",
         requesUrl: "",
         ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId,
         showStatus: false,
         actionData: {},
         //--------
         typeList: [],//手术类型列表
         operationList: [],//手术包列表
         treeList: [],//手术类型+手术包组合tree
         defaultActive: "",
         defaultObj: {},
         importShow: false,
         importType: "",
         url: "",
      };
   },
   //方法集合
   methods: {
      // 触发组件的提交
      fileSuccess(val) {
      },
      // 关闭弹窗
      closeExcel(val) {
         this.importShow = false
         if (val) {
            this.getType()
         }
      },
      exportTemplate() {
         window.location.href = `${window.global_config.BASE_URL}/surgerymaster/importTemplate`
      },
      importDetails() {
         this.importType = 'surgerymasterexporSurgery'
         this.url = 'surgerymaster/exporSurgery'
         this.importShow = true
      },
      //--------------------------------
      toTab(val) {
         this.treeList.forEach(item => {
            if (item.children && item.children.length > 0) {
               const obj = item.children.find(val1 => val1.umId == val);
               if (obj) {
                  this.defaultObj = {
                     surgeryName: item.surgeryName,
                     ...obj
                  };
               }
            }
         });
         this.defaultActive = String(val)
         this.getDataList()
      },
      // 子组件触发
      drawerCancel(e) {
         this.showStatus = false;
         if (e == 1) this.getType()
      },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         console.log(orderId)
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true;
         this.seId = sId;
         this.sField = sField;
         this.parentSearchData[type] = this.getRequestData[type];
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val);
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.getRequestData[item] = val[item];
         });
      },

      // 获取数据列表
      async getPageInfo() {
         var obj = this.$common.getSearchData(this.formList, 'page', "rows", 30, true)
         for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
         }
         this.getButtonList()
      },
      clear(val) {
         if (val) {
            var arr = val.split(",")
            arr.forEach(item => {
               this.$set(this.getRequestData, item, "")
            })
         }
      },
      // 动作集合
      actionSet(actionData) {
         console.log(actionData);
         switch (actionData.actionType) {
            case 0:
               this.showStatus = true
               this.actionData = {
                  cate: 0,
                  oldData: "",
                  orderId: "",
               }
               break;
            case 1:
               this.showStatus = true
               this.$set(this.defaultObj, 'surgerydetailList', this.returnData.list)
               this.actionData = {
                  cate: 1,
                  oldData: this.defaultObj,
                  orderId: "",
               }
               break;
            case 2:
               this.delOnSub()
               break;
            case 3:
               this.exportTemplate()
               break;
            case 4:
               this.importDetails()
               break;
         }
      },
      delOnSub() {
         if (this.defaultActive === '') {
            return this.$message.error("请选中要删除的手术包！")
         }
         this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            let id = ''
            if(this.defaultActive && typeof this.defaultActive === 'string' && this.defaultActive.includes("_")){
               id=this.defaultActive.split("_")[0]
            }
            var delData = {
               ids: [id]
            }
            let responseData = await this.$http.surgerymasterdelete(delData)
            if (responseData.status == 200) {
               this.$message({
                  type: 'success',
                  message: '删除成功!'
               });
               this.getType()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }

         }).catch(() => { });
      },
      // 数据搜索
      searchData() {
         this.getType();
      },

      // 获取数据列表
      async getDataList() {
         const params = []
         if (this.defaultActive.indexOf("_1") == -1) {
            params.push(this.defaultActive)
         } else {
            params.push(Number(this.defaultActive.split("_")[0]))
         }
         let responseData = await this.$http.surgerymasterqueryDetail({ ids: params });
         if (responseData.status == 200) {
            this.returnData.list = responseData.result
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key === val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr;
         } catch (ex) {
            return str;
         }
      },
//手术类型列表
      async getType() {
         this.treeList = []
         const res = await this.$http.dictSurgeryqueryList({ surgeryName: this.getRequestData.surgeryName })
         if (res.status == 200) {
            this.typeList = res.result
            this.typeList.unshift({
               id: -1,
               surgeryName: "全部",
               surgeryType: "全部",
            })
            this.getOperationKits()//手术包
         }

      },
      //手术包
      async getOperationKits() {
         const res = await this.$http.surgerymasterqueryList({ umName: this.getRequestData.umName })
         if (res.status == 200) {
            this.operationList = res.result
            // 假设 this.typeList 为手术类型（父级），this.operationList 为手术包（子级）
            const treeList = this.typeList.map(type => {
               // 找出所有属于该类型的手术包
               let children = this.operationList.filter(
                  kit => Number(kit.surgeryType) === type.id
               );
               if (type.id != -1) {
                  // 返回树节点
                  return {
                     ...type,
                     children: children
                  };
               } else {
                  let arr = JSON.parse(JSON.stringify(this.operationList))
                  arr.forEach(item => {
                     item.umId = item.umId + "_1"
                  })
                  return {
                     ...type,
                     children: arr
                  }
               }

            });
            // 赋值到 treeList
            this.treeList = treeList;
            if (this.treeList.length > 0) {
               if (this.treeList[0].children.length > 0) {
                  this.defaultActive = String(this.treeList[0].children[0].umId)
                  this.defaultObj = {
                     surgeryName: this.treeList[0].surgeryName,
                     ...this.treeList[0].children[0]
                  }
               } else {
                  this.treeList.forEach((item, index) => {
                     if (item.children.length > 0) {
                        this.defaultActive = String(this.treeList[index].children[0].umId)
                        var obj = this.treeList.filter(val => val.id == this.treeList[index].children[0].surgeryType)[0]
                        this.defaultObj = {
                           surgeryName: obj.surgeryName,
                           ...this.treeList[index].children[0],
                        }
                     }
                  })
               }
            }
            console.log(this.treeList, this.defaultActive);

            this.getDataList()
         }
      },
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
         console.log(this.buttonList, '按钮');
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.getPageInfo()
      this.getType()//手术类型列表
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {


   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.tableHeight = this.$common.getTableHeight()
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.page_content_center {
   display: flex;
   justify-content: space-between;
}

.left {
   flex-shrink: 0;
}

.el-menu-vertical-demo {
   width: 200px;
}

.right {
   width: calc(100vw - 220px);
}

.right_top {
   padding: 5px;
   background-color: #409eff;
}

::v-deep .el-menu-item,
::v-deep .el-submenu__title {
   height: 30px;
   line-height: 30px;
}

::v-deep .el-menu-item-group__title {
   padding: 0;
}

::v-deep .el-breadcrumb__inner,
::v-deep .el-breadcrumb__separator {
   color: #fff !important;
   font-size: 15px;
   font-weight: bold;
}
</style>